import React from "react";
import classes from "./Services.module.css";
import Helpers from "../../utils/Helpers";
import { useNavigate } from "react-router-dom";
import { images } from "../../assets/img";
import BookNowBtn from "../BookNowBtn";
import "../../index.css";
import { getServicePrice } from "../../utils/PriceList";

const SERVICES = [
  {
    title: "Hands Gel Polish",
    description: "SHELLAC",
    image: "https://nhakhoabacsihuy-solcomarketing.sgp1.cdn.digitaloceanspaces.com/website-images/shine-my-nails/NNpVLLe.jpeg",
    price: getServicePrice("Hands", "Gel Polish (Shellac)"),
  },
  {
    title: "Toes Gel Polish",
    description: "",
    image: "https://nhakhoabacsihuy-solcomarketing.sgp1.cdn.digitaloceanspaces.com/website-images/shine-my-nails/D2HJoWa.jpeg",
    price: getServicePrice("Toes", "Gel Polish"),
  },
  {
    title: "Builder Gel",
    description: "BIAB",
    image: "https://nhakhoabacsihuy-solcomarketing.sgp1.cdn.digitaloceanspaces.com/website-images/shine-my-nails/pBjO4ry.jpeg",
    price: getServicePrice("Nail Extensions", "Builder Gel (BIAB)"),
  },
  {
    title: "Hands Full Manicure + Gel",
    description: "",
    image: "https://nhakhoabacsihuy-solcomarketing.sgp1.cdn.digitaloceanspaces.com/website-images/shine-my-nails/PtkDJFt.jpeg",
    price: getServicePrice("Hands", "Full Manicure + Gel"),
  },

  {
    title: "Nail Extensions Colour Power",
    description: "Full Set",
    image: "https://nhakhoabacsihuy-solcomarketing.sgp1.cdn.digitaloceanspaces.com/website-images/shine-my-nails/A9BUYT2.jpeg",
    price: getServicePrice("Nail Extensions", "Colour Power"),
  },
];

const ServiceItem = (item, index, onPress) => {
  const { title, image, description, price } = item || {};
  return (
    <div
      onClick={onPress}
      key={`${title + index}`}
      className={`${classes.serviceItem}`}
    >
      <div className={classes.rowContainer}>
        <div className={`${classes.roundDiv}`}>
          <img alt={"nail"} src={image} loading="lazy" decoding="async" />
        </div>
        <div>
          <h3 className={classes["change-color-on-hover"]}>{title}</h3>
          <h4 className={classes["change-color-on-hover"]}>{description}</h4>
        </div>
      </div>

      <h3 className={classes["change-color-on-hover"]}>{price}</h3>
    </div>
  );
};

const Services = (props) => {
  const navigate = useNavigate();

  const onPress = () => {
    navigate(`/services`);
  };

  return (
    <div ref={props?.serviceRef} className={classes.wrapper}>
      <h1>Our Services</h1>

      <div className={classes.rowDirection}>
        <div className={classes.container}>
          {Helpers.isArrayAvailable(SERVICES)
            ? SERVICES.map((item, index) => {
                return ServiceItem(item, index, onPress);
              })
            : null}
        </div>
        <img
            alt={"Service"}
            src={images.nail3}
            className={classes.serviceImg}
            loading="lazy"
            decoding="async"
          />
      </div>

      <BookNowBtn
        style={classes.priceListBtn}
        onClick={() => navigate("/services")}
        title={"VIEW PRICING"}
      />
    </div>
  );
};

export default Services;
